module.exports = __webpack_public_path__ + "img/9.7c2ec554.jpg";